<template>
  <span class="inline-flex">
    <!-- tao moi -->
    <i :class="iconClasses"></i>
  </span>
</template>

<script>
  export default {
    name: "base-filter-icon",
    props: ['iconClasses'],
    data() {
      return {};
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/base-filter-icon.vue